// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfirmTradesStepV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfirmTradesStepV2Query = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
  , relevantProjectBidPackages: Array<{ __typename?: 'RelevantProjectBidPackage', id: string, totalCostInCents: number, bidPackage: { __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } }, preferredBidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined, bidder: { __typename?: 'BidPackageBidder', id: string, name: string } } }, existingSignedCommitments: Array<
      | { __typename?: 'Commitment', id: string, shortName: string, status: Types.CommitmentStatus, blueprintUrl: { __typename?: 'Url', path: string }, project:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
         }
      | { __typename?: 'CommitmentChangeOrder', id: string, shortName: string, status: Types.CommitmentStatus, blueprintUrl: { __typename?: 'Url', path: string }, project:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
         }
    > }> };

export type AssignBidPackageWorkToBidContractMutationVariables = Types.Exact<{
  input: Types.AssignBidPackageWorkToBidContractInput;
}>;


export type AssignBidPackageWorkToBidContractMutation = { __typename?: 'Mutation', assignBidPackageWorkToBidContract: Array<{ __typename?: 'Commitment', id: string }> };

export type ConfirmTradesStepV2_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Region_Fragment = { __typename?: 'Region', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Market_Fragment = { __typename?: 'Market', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Community_Fragment = { __typename?: 'Community', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Lot_Fragment = { __typename?: 'Lot', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Structure_Fragment = { __typename?: 'Structure', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_Project_Unit_Fragment = { __typename?: 'Unit', id: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, displayName: string }
      | { __typename?: 'PlanPackage', id: string, displayName: string }
      | { __typename?: 'DesignPackage', id: string, displayName: string }
      | { __typename?: 'ProductOffering', id: string, displayName: string }
     | null | undefined } | null | undefined };

export type ConfirmTradesStepV2_ProjectFragment =
  | ConfirmTradesStepV2_Project_StandaloneProject_Fragment
  | ConfirmTradesStepV2_Project_Region_Fragment
  | ConfirmTradesStepV2_Project_Market_Fragment
  | ConfirmTradesStepV2_Project_Community_Fragment
  | ConfirmTradesStepV2_Project_Subdivision_Fragment
  | ConfirmTradesStepV2_Project_Lot_Fragment
  | ConfirmTradesStepV2_Project_Structure_Fragment
  | ConfirmTradesStepV2_Project_Unit_Fragment
;

export type ConfirmTradesStepV2_RelevantProjectBidPackageFragment = { __typename?: 'RelevantProjectBidPackage', id: string, totalCostInCents: number, bidPackage: { __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } }, preferredBidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined, bidder: { __typename?: 'BidPackageBidder', id: string, name: string } } }, existingSignedCommitments: Array<
    | { __typename?: 'Commitment', id: string, shortName: string, status: Types.CommitmentStatus, blueprintUrl: { __typename?: 'Url', path: string }, project:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       }
    | { __typename?: 'CommitmentChangeOrder', id: string, shortName: string, status: Types.CommitmentStatus, blueprintUrl: { __typename?: 'Url', path: string }, project:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       }
  > };

export const ConfirmTradesStepV2_ProjectFragmentDoc = gql`
    fragment ConfirmTradesStepV2_Project on Project {
  id
  readyPlanConfig {
    id
    readyPlan {
      ...DisplayNamed
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const ConfirmTradesStepV2_RelevantProjectBidPackageFragmentDoc = gql`
    fragment ConfirmTradesStepV2_RelevantProjectBidPackage on RelevantProjectBidPackage {
  id
  totalCostInCents
  bidPackage {
    id
    name
    costCodes {
      ...DisplayNamed
    }
    isUnitBased
    costType {
      code
      name
    }
  }
  preferredBidContractRevision {
    id
    bidContract {
      id
      isInternalEstimate
      internalEstimateType {
        code
      }
      bidder {
        id
        name
      }
    }
  }
  existingSignedCommitments {
    id
    shortName
    status
    blueprintUrl {
      path
    }
    project {
      id
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const ConfirmTradesStepV2Document = gql`
    query ConfirmTradesStepV2($id: ID!) {
  project(id: $id) {
    ...ConfirmTradesStepV2_Project
  }
  relevantProjectBidPackages(projectId: $id) {
    ...ConfirmTradesStepV2_RelevantProjectBidPackage
  }
}
    ${ConfirmTradesStepV2_ProjectFragmentDoc}
${ConfirmTradesStepV2_RelevantProjectBidPackageFragmentDoc}`;

/**
 * __useConfirmTradesStepV2Query__
 *
 * To run a query within a React component, call `useConfirmTradesStepV2Query` and pass it any options that fit your needs.
 * When your component renders, `useConfirmTradesStepV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmTradesStepV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmTradesStepV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables> & ({ variables: ConfirmTradesStepV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
      }
export function useConfirmTradesStepV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
        }
// @ts-ignore
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>;
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfirmTradesStepV2Query | undefined, ConfirmTradesStepV2QueryVariables>;
export function useConfirmTradesStepV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>(ConfirmTradesStepV2Document, options);
        }
export type ConfirmTradesStepV2QueryHookResult = ReturnType<typeof useConfirmTradesStepV2Query>;
export type ConfirmTradesStepV2LazyQueryHookResult = ReturnType<typeof useConfirmTradesStepV2LazyQuery>;
export type ConfirmTradesStepV2SuspenseQueryHookResult = ReturnType<typeof useConfirmTradesStepV2SuspenseQuery>;
export type ConfirmTradesStepV2QueryResult = Apollo.QueryResult<ConfirmTradesStepV2Query, ConfirmTradesStepV2QueryVariables>;
export const AssignBidPackageWorkToBidContractDocument = gql`
    mutation AssignBidPackageWorkToBidContract($input: AssignBidPackageWorkToBidContractInput!) {
  assignBidPackageWorkToBidContract(input: $input) {
    id
  }
}
    `;
export type AssignBidPackageWorkToBidContractMutationFn = Apollo.MutationFunction<AssignBidPackageWorkToBidContractMutation, AssignBidPackageWorkToBidContractMutationVariables>;

/**
 * __useAssignBidPackageWorkToBidContractMutation__
 *
 * To run a mutation, you first call `useAssignBidPackageWorkToBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignBidPackageWorkToBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignBidPackageWorkToBidContractMutation, { data, loading, error }] = useAssignBidPackageWorkToBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignBidPackageWorkToBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignBidPackageWorkToBidContractMutation, AssignBidPackageWorkToBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignBidPackageWorkToBidContractMutation, AssignBidPackageWorkToBidContractMutationVariables>(AssignBidPackageWorkToBidContractDocument, options);
      }
export type AssignBidPackageWorkToBidContractMutationHookResult = ReturnType<typeof useAssignBidPackageWorkToBidContractMutation>;
export type AssignBidPackageWorkToBidContractMutationResult = Apollo.MutationResult<AssignBidPackageWorkToBidContractMutation>;
export type AssignBidPackageWorkToBidContractMutationOptions = Apollo.BaseMutationOptions<AssignBidPackageWorkToBidContractMutation, AssignBidPackageWorkToBidContractMutationVariables>;